import React from 'react';
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import '../components/infoList_style.css';

export default function InfoList({ data }) {
  return (
    <div className="main-list-container">
      <div className="list-container">
        <Image src={asset(data.image)} alt="icons" height={53} width={70} />
        <div className="list-text-container">
          <p className="list-text">{data.content}</p>
        </div>
      </div>
    </div>
  )
}